<template>
  <header class="header">
    <div class="header__item header__burger-wrap">
      <div class="button-burger" :class="menuActiveMobile ? 'active' : ''" @click="toggleMainMenu">
        <span class="button-burger__line"></span>
        <span class="button-burger__line"></span>
        <span class="button-burger__line"></span>
      </div>
    </div>
    <div class="header__item">
      <div class="user-info" @click.prevent.stop="onClick">
        <div class="user-avatar user-info__avatar">
          <img v-if="currentUserData.avatar !== null" :src="currentUserData.avatar" :alt="currentUserData.full_name">
          <img v-else src="/img/svg/avatar__icon.svg" :alt="currentUserData.full_name">
        </div>
        <div class="user-info__username">{{ currentUserData.full_name }}</div>
        <div class="drop-icon user-info__icon" :class="currentUserData.menu.is_active ? 'drop-icon_active' : ''">
          <svg class="dropdown-icon" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
        <transition name="fade">
          <div v-if="currentUserData.menu.is_active"
               class="user-info__popup-menu">
            <AppHeaderPopup @log-out="logOut"/>
          </div>
        </transition>
      </div>
    </div>
  </header>
</template>

<script>
import AppHeaderPopup from './AppHeaderPopup.vue'
export default {
  name: 'AppHeader',
  components: {
    AppHeaderPopup
  },
  computed: {
    menuActiveMobile () {
      return this.$store.getters.mainMenu.is_active_mobile
    },
    mediaBreakpoint () {
      return this.$store.getters.getMediaBreakpoint
    },
    currentUserData () {
      return this.$store.getters.currentUserData
    }
  },
  methods: {
    toggleMainMenu () {
      this.$store.commit('TOGGLE_MAIN_MENU_MOBILE')
    },
    onClick () {
      this.$store.dispatch('toggleHeaderMenu')
    },
    logOut () {
      this.$emit('log-out')
    }
  }
}
</script>

<style lang="scss" scoped>

.header {
  position: relative;
  z-index: 1000;
  width: 100%;
  padding: 10px 30px 10px 290px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  height: $header_height;
  border-bottom: 2px solid $color__smoke;

  &__item {
    @media screen and (max-width: $tablet_start) {
      margin-right: 10px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__burger-wrap {
    margin-right: auto;
    display: none;

    @media screen and (max-width: $tablet_start) {
      display: block;
    }
  }

  &__mobile-menu-list {
    display: none;
    height: 100%;

    @media screen and (max-width: $tablet_start) {
      display: block;
    }
  }

  @media screen and (max-width: $tablet_start) {
    background: $color_second;
    height: $header_height_mobile;
    padding: 6px 6px 6px 10px;
  }
}

.user-info {
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  width: 100%;
  // min-width: 190px;

  @media screen and (max-width: $tablet_start) {
    min-width: unset;
  }

  &__avatar {
    margin-right: 10px;
    background-color: $color__forest-wolf;

    @media screen and (max-width: $tablet_start) {
      margin-right: 0;
    }
  }

  &__username {
    color: $color__brown;
    margin-right: 10px;

    @media screen and (max-width: $tablet_start) {
      display: none;
    }
  }

  &__icon {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color__brown;
    transition: .3s;

    @media screen and (max-width: $tablet_start) {
      display: none;
    }
  }

  &__popup-menu {
    position: absolute;
    z-index: 99;
    left: auto;
    right: 0;
    top: calc(#{$header_height} + 10px);

    @media screen and (max-width: $tablet_start) {
      top: calc(#{$header_height_mobile} + 6px);
      width: 193px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.button-burger {
  width: 22px;
  height: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;

  &__line {
    display: block;
    height: 2px;
    background-color: #ffffff;
    transition: .3s;
  }

  &.active {
    .button-burger__line:first-child {
      transform: translate3d(0, 7px, 0) rotate(-45deg);
    }

    .button-burger__line:nth-child(2) {
      opacity: 0;
    }

    .button-burger__line:last-child {
      transform: translate3d(0, -7px, 0) rotate(45deg);
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.error__report {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: $font_color_second;
  font-family: "Fira Sans", Arial, sans-serif;
  line-height: 19px;
  margin-right: 31px;
  transition: 0.2s;

  &:hover {
    color: #C01082;
  }
}
</style>
